import { configureStore } from "@reduxjs/toolkit";
import commonReducer from "./slice"; 

export const store = configureStore({
  reducer: {
    data: commonReducer,
  },
});

export default store;
